import React from 'react';
import { Link } from 'react-router-dom';
import { KeyIcon } from '@heroicons/react/24/outline';
import UsageTab from '../components/converter/UsageTab';
import CliUsageTab from '../components/converter/CliUsageTab';
import WebUsageTab from '../components/converter/WebUsageTab';
import { urlEnum, useUrlState } from '../hooks/useUrlState';

type UsageScope = 'api' | 'cli' | 'web';

const scopeTabs: { id: UsageScope; label: string }[] = [
    { id: 'cli', label: 'CLI' },
    { id: 'api', label: 'API' },
    { id: 'web', label: 'WEB' },
];

const URL_SPEC = {
    tab: urlEnum(['cli', 'api', 'web'] as const, 'cli'),
};

function Usage() {
    const [{ tab: activeScope }, setUrlState] = useUrlState(URL_SPEC);
    const selectScope = (scope: UsageScope) => setUrlState({ tab: scope });

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                    <h1 className="text-2xl font-bold text-heading">Usage Analytics</h1>
                    <span className="bg-warning/20 text-warning px-2 py-0.5 rounded text-xs font-bold uppercase tracking-wider border border-warning/40">
                        BETA
                    </span>
                </div>
                <Link to="/settings?tab=api-keys" className="btn-subtle text-sm flex items-center gap-2">
                    <KeyIcon className="w-4 h-4" />
                    Manage API Keys
                </Link>
            </div>
            <div className="border-b border-gray-700 mb-6">
                <nav className="flex space-x-8">
                    {scopeTabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => selectScope(tab.id)}
                            className={`pb-3 px-1 font-medium text-sm transition-colors ${
                                activeScope === tab.id
                                    ? 'border-b-2 border-primary text-primary'
                                    : 'text-secondary hover:text-body-color'
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>
            <p className="text-xs text-secondary mb-3">All dates and times are UTC.</p>
            {/* Only the active tab is mounted: a switch refetches it, and a hidden tab never fetches. */}
            {activeScope === 'cli' && <CliUsageTab urlPrefix="cli" />}
            {activeScope === 'api' && <UsageTab urlPrefix="api" />}
            {activeScope === 'web' && <WebUsageTab urlPrefix="web" />}
        </div>
    );
}

export default Usage;
